import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, IStorageLocal } from "namirasoft-core";
import { CostRow } from "namirasoft-cost";
import { CostRoutes } from './CostRoutes';
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, IntegerFormatter, MoneyFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftMap } from "namirasoft-site-map";
import { CostRouterProps } from "./CostRouterProps";

export class CostEntities
{
    static cost(props: NSARouterMakerResult & CostRouterProps, extra_filters: FilterItem[]): IEntityInfo<CostRow, CostRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_COST,
            name: "Cost",
            tables: [{ table: namirasoft.cost.tables.cost, required: true }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.resource_entity, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.resource_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.period_start, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.period_end, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.seconds, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.percent, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.count, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.usage_name, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.usage_unit, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.usage_base, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.usage_amount, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.usage_total, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.token_base, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.token_amount, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.token_total, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.price_base, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.price_amount, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.price_total, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.price_discount, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.price_payable, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.currency, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.cost.tables.cost.columns.created_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => CostRoutes.CostList,
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: null,
            },
            server: {
                value_list: props.servers.cost.value.List,
                list: (filters, page, size, sorts) => props.servers.cost.cost.List([...(filters ?? []), ...extra_filters], page, size, sorts, null),
                get: null,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
}